(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["quote-request"] && !Shopify.designMode) return;
  try {
    (() => {

  if (window.quoteRequestModalInitialized) return;

  window.quoteRequestModalInitialized = true;


  document.addEventListener('click', (event) => {

    const openButton = event.target.closest('[data-quote-modal-open]');

    if (openButton) {

      const modal = document.getElementById(
        openButton.getAttribute('data-quote-modal-open')
      );

      if (modal && typeof modal.showModal === 'function') {
        modal.showModal();
      }

      return;
    }


    const closeButton = event.target.closest('[data-quote-modal-close]');

    if (closeButton) {
      closeButton.closest('dialog')?.close();
      return;
    }


    if (
      event.target instanceof HTMLDialogElement &&
      event.target.classList.contains('quote-request-modal')
    ) {

      const rect = event.target.getBoundingClientRect();

      const inside =
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom;

      if (!inside) {
        event.target.close();
      }

    }

  });


  document.addEventListener('change', (event) => {

    const modal = event.target.closest('.quote-request-modal');

    if (!modal) return;


    if (event.target.matches('[data-quote-old-floor]')) {

      const field = modal.querySelector('[data-quote-old-floor-type]');

      if (field) {
        field.hidden = event.target.value !== 'Tak';
      }

    }


    if (event.target.matches('[data-quote-heating-process]')) {

      const field = modal.querySelector('[data-quote-heating-report]');

      if (field) {
        field.hidden = event.target.value !== 'Tak';
      }

    }

  });


  const updateProductData = () => {

    document.querySelectorAll('.quote-request-modal').forEach((modal) => {

      const productSection =
        modal.closest('.shopify-section') ||
        document.querySelector('[data-testid="product-information"]');

      const variantInput =
        productSection?.querySelector('form[action*="/cart/add"] [name="id"]') ||
        document.querySelector('form[action*="/cart/add"] [name="id"]');

      if (!variantInput?.value) return;

      const variantId = String(variantInput.value);

      const productJsonElement =
        productSection?.querySelector('script[type="application/json"]') ||
        document.querySelector(
          'script[type="application/json"][data-product-json]'
        );

      if (!productJsonElement) return;

      try {

        const data = JSON.parse(productJsonElement.textContent);

        const variants =
          data.variants ||
          data.product?.variants ||
          [];

        const variant = variants.find(
          (item) => String(item.id) === variantId
        );

        if (!variant) return;

        const titleInput =
          modal.querySelector('[data-quote-variant-title]');

        const skuInput =
          modal.querySelector('[data-quote-variant-sku]');

        if (titleInput) {
          titleInput.value = variant.title || '';
        }

        if (skuInput) {
          skuInput.value = variant.sku || '';
        }

      } catch (error) {

        console.warn(
          'Nie udało się odczytać wariantu produktu.',
          error
        );

      }

    });

  };


  document.addEventListener('change', updateProductData);

  document.addEventListener('variant:change', updateProductData);

})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sample-request"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.sampleRequestModalInitialized) return;
    window.sampleRequestModalInitialized = true;

    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-sample-modal-open]');

      if (openButton) {
        const modal = document.getElementById(
          openButton.getAttribute('data-sample-modal-open')
        );

        if (modal && typeof modal.showModal === 'function') {
          modal.showModal();
        }

        return;
      }

      const closeButton = event.target.closest('[data-sample-modal-close]');

      if (closeButton) {
        closeButton.closest('dialog')?.close();
        return;
      }

      if (
        event.target instanceof HTMLDialogElement &&
        event.target.classList.contains('sample-request-modal')
      ) {
        const rect = event.target.getBoundingClientRect();
        const inside =
          event.clientX >= rect.left &&
          event.clientX <= rect.right &&
          event.clientY >= rect.top &&
          event.clientY <= rect.bottom;

        if (!inside) {
          event.target.close();
        }
      }
    });

    const updateProductData = () => {
      document.querySelectorAll('.sample-request-modal').forEach((modal) => {
        const productSection =
          modal.closest('.shopify-section') ||
          document.querySelector('[data-testid="product-information"]');

        const variantInput =
          productSection?.querySelector('form[action*="/cart/add"] [name="id"]') ||
          document.querySelector('form[action*="/cart/add"] [name="id"]');

        if (!variantInput?.value) return;

        const variantId = String(variantInput.value);
        const productJsonElement =
          productSection?.querySelector('script[type="application/json"]') ||
          document.querySelector('script[type="application/json"][data-product-json]');

        if (!productJsonElement) return;

        try {
          const data = JSON.parse(productJsonElement.textContent);
          const variants = data.variants || data.product?.variants || [];
          const variant = variants.find(
            (item) => String(item.id) === variantId
          );

          if (!variant) return;

          const titleInput = modal.querySelector('[data-sample-variant-title]');
          const skuInput = modal.querySelector('[data-sample-variant-sku]');

          if (titleInput) titleInput.value = variant.title || '';
          if (skuInput) skuInput.value = variant.sku || '';
        } catch (error) {
          console.warn('Nie udało się odczytać wariantu produktu.', error);
        }
      });
    };

    document.addEventListener('change', updateProductData);
    document.addEventListener('variant:change', updateProductData);
  })();
  } catch(e) { console.error(e); }
})();

})();
